module.exports = __webpack_public_path__ + "static/img/200328.41974519.png";